
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductsByCategory } from "../../Redux/slice/productSlice";
import { Card, Button, Tag } from "antd";
import { ShoppingCartOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

const Phones = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { productsByCategory = {}, loading: productsLoading } = useSelector((state) => state.products);
  const [imageLoading, setImageLoading] = useState({});
  const GTM_ID = "GTM-WKCL4JTV"; // Your GTM ID
  const hardcodedCategoryId = "51d1fff2-7b71-46aa-9b34-2e553a40e921";

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchProductsByCategory(hardcodedCategoryId));
  }, [dispatch]);

  const filteredProducts = useMemo(() => {
    return (productsByCategory[hardcodedCategoryId] || [])
      .slice()
      .sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));
  }, [productsByCategory]);


  const formatPrice = (amount) =>
    amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const handleImageLoad = (productId) => {
    setImageLoading((prev) => ({ ...prev, [productId]: false }));
  };

  const handleImageError = (productId) => {
    setImageLoading((prev) => ({ ...prev, [productId]: true }));
  };



  if ( productsLoading) {
    return (
      <div className="max-w-6xl mx-auto p-4 mt-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {Array.from({ length: 12 }).map((_, index) => (
            <div key={index} className="animate-pulse border rounded-lg shadow-lg p-3 bg-gray-100">
              <div className="h-40 bg-gray-300 rounded-md"></div>
              <div className="mt-2 h-4 bg-gray-300 rounded w-3/4"></div>
              <div className="mt-1 h-4 bg-gray-300 rounded w-1/2"></div>
              <div className="mt-3 h-8 bg-gray-300 rounded w-10 self-end"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }const getValidImageUrl = (imagePath) => {
    if (!imagePath) return "default-image-url";
    if (imagePath.includes("\\")) {
      return `https://smfteapi.salesmate.app/Media/Products_Images/${imagePath.split("\\").pop()}`;
    }
    return imagePath;
  };
  
  <noscript>
  <iframe
    src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
    height="0"
    width="0"
    style={{ display: "none", visibility: "hidden" }}
    title="Google Tag Manager"
  ></iframe>
</noscript>

  return (
    <div className="max-w-6xl mx-auto py-6 px-4">


      {/* Section Title */}
   {/* Section Header */}
<div className="flex flex-col items-center text-center my-6">
  <span className="text-sm font-semibold text-red-500 tracking-wide">BEST & QUALITY</span>
  <div className="relative w-full flex items-center justify-center">
    <hr className="w-1/4 border-gray-300 hidden md:block" />
    <h2 className="text-xl md:text-2xl font-bold text-gray-800 mx-4">
      PHONES & TABLETS
    </h2>
    <hr className="w-1/4 border-gray-300 hidden md:block" />
  </div>
</div>


      {/* Products Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-4">
        {filteredProducts.map((item) => (
          <Card
          key={item.productID} // Ensure consistency with item.productID
          hoverable
          className="rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-xl group relative"
          cover={
            <div
              onClick={() => navigate(`/product/${item.productID}`)}
              className="cursor-pointer relative h-full flex items-center justify-center"
            >
              <div className="h-40 flex items-center justify-center">
                {imageLoading[item.productID] ? (
                  <img
                    src="./frankoIcon.png"
                    alt="Default"
                    className="w-40 object-cover rounded-lg"
                  />
                ) : (
                  <img
                  src={getValidImageUrl(item.productImage)}

                    alt={item.productName}
                    className="w-40 object-cover rounded-lg"
                    onLoad={() => handleImageLoad(item.productID)}
                    onError={() => handleImageError(item.productID)}
                  />
                )}
              </div>
            </div>
          }
        >
          <div className="flex flex-col">
            <p className="font-semibold text-sm line-clamp-2">{item.productName}</p>
            <p className="text-red-500 font-bold text-sm">₵{formatPrice(item.price)}</p>
          </div>
          <Tag color="green">{item.brandName}</Tag>
          <Button
            shape="circle"
            icon={<ShoppingCartOutlined />}
            className="absolute bottom-4 right-4 bg-red-500 text-white opacity-0 group-hover:opacity-100 transition-opacity"
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
        </Card>
        
        ))}
      </div>


    </div>
  );
};

export default Phones;